// extracted by mini-css-extract-plugin
module.exports = {"container":"ScoreLimits_container__2pWbV Div_Div__38Xlj Div_RowContainer__2W4x_","title":"ScoreLimits_title__1q8j7 Title_Title__3Em2w"};